import FinTronConfig from '@fintronners/react-config/src/Config/FinTronConfig';

export default {
  profileSettings: {
    basicInformation: 'Basic information',
    address: 'Address',
    citizenshipStatus: 'Citizenship status',
    investorInformation: 'Investor information',
    riskProfile: 'Risk profile',
    saveSuccess: 'You have successfully submitted your changes.',
    saveError: `We were unable to save your changes. Please try again later. If the issue persists, contact ${FinTronConfig.supportEmail}.`,
  },
  bankLink: {
    title: 'Linked bank accounts',
    description: `Change or update your bank linkage by using Plaid. Select a bank account below or add a new account to enter Plaid.\n\nManage your linked bank accounts for ${FinTronConfig.robo.name} and ${FinTronConfig.selfDirected.name} by using Plaid, a third-party bank verification tool.`,
    account: '{{ account }} account',
    discretionaryDescription: '',
  },
  profileUpdates: {
    title: 'Update info',
    description: `This information update will be applied to all your open ${FinTronConfig.clearingFirm}. accounts, including those associated with ${FinTronConfig.robo.name} and ${FinTronConfig.selfDirected.name}.`,
    yesUpdate: 'Yes, Update',
  },
  security: {
    title: 'Security',
    password: 'Update password',
    twoFactorAuth: 'Two-factor Authentication',
    login: 'Login',
    loginDescription:
      'We will send you an email or text with the two-factor authentication code for each login.',
    riskProfile: {
      form: {
        question: 'What is your risk tolerance?',
      },
      infograph: {
        title: 'Risk tolerance',
        conservative: {
          pre: 'A',
          bold: 'conservative investor',
          post: 'values stability more than higher return and prefers less risk and downside potential.',
        },
        moderate: {
          pre: 'A',
          bold: 'moderate investor',
          post: 'balanced approach to growth of capital with preserving capital and accepting of some risk.',
        },
        aggressive: {
          pre: 'An',
          bold: 'aggressive investor',
          post: 'values higher return more than stability and is willing to accept greater risk and greater downside potential.',
        },
        footer:
          'You will receive investment recommendations that align with your chosen risk profile in order to progress toward the full amount of your goal within the desired timeframe.',
      },
      success: {
        message: 'Your risk tolerance was updated successfully.',
      },
    },
    changePassword: {
      usernameForm: {
        title: 'Change Password',
        description:
          'Please enter the username associated with your account and we will send you a password reset code via email.',
        usernamePlaceholder: 'Username',
        send: 'Send',
        sending: 'Sending...',
      },
      resetForm: {
        title: 'New password',
        description: 'Please reset your password below.',
        codeLabel: 'Code',
        codePlaceholder: 'Enter password code',
        codeDescription:
          "We've sent your password reset code via email. Please enter it above to continue with your password reset.",
        passwordLabel: 'New password',
        passwordPlaceholder: 'Enter new password',
        passwordDescription:
          'Your password must be a minimum of 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character for enhanced security.',
        confirmPasswordLabel: 'Confirm new password',
        confirmPasswordPlaceholder: 'Enter new password',
      },
      success: {
        title: 'Success!',
        description: 'Your password has been reset.',
      },
    },
  },
  investmentQuestions: {
    title: 'Investment questions',
    notSure: "If you aren't sure, it likely doesn't apply.",
    experienceLevelQuestion: 'What is your investing level of experience?',
    annualIncomeOptions: {
      _025000: 'Less than or equal to $25,000',
      _2500150000: '$25,001-$50,000',
      _50001100000: '$50,001-$100,000',
      _100001200000: '$100,001-$200,000',
      _200001300000: '$200,001-$300,000',
      _300001500000: '$300,001-$500,000',
      _5000011000000: '$500,001-$1,000,000',
      _5000011200000: '$500,001-$1,200,000',
      _10000015000000: '$1,000,001-$5,000,000',
      _12000019999999: '$1,200,001-$9,999,999',
      _50000019999999: '$5,000,001-$9,999,999',
      Unspecified: 'Unspecified',
    },
    netWorthOptions: {
      _025000: 'Less than or equal to $25,000',
      _050000: 'Less than or equal to $50,000',
      _2500150000: '$25,001-$50,000',
      _50001100000: '$50,001-$100,000',
      _100001200000: '$100,001-$200,000',
      _200001300000: '$200,001-$300,000',
      _200001500000: '$200,001-$500,000',
      _300001500000: '$300,001-$500,000',
      _5000011000000: '$500,001-$1,000,000',
      _10000015000000: '$1,000,001-$5,000,000',
      _50000019999999: '$5,000,001-$9,999,999',
      Unspecified: 'Unspecified',
    },
    netWorthRangeInfoTitle: 'Finding Your Net Worth',
  },
  investorInformation: {
    investing: 'Investing',
    personal: 'Personal',
    compliance: 'Compliance',
    investmentExperience: 'Investment experience',
    investmentObjective: 'Investment objective',
    investmentTimeHorizon: 'Investment time horizon',
    importanceOfCashOnHand: 'Importance of cash on hand',
    marriageStatus: 'Marriage status',
    employmentStatus: 'Employment status',
    annualIncome: 'Annual income',
    netWorth: 'Net worth',
  },
};
